import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { LIFECYCLE } from '../../data/dgpt';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
const STAGE_DETAIL: Record<(typeof LIFECYCLE)[number], {
  module: string;
  metric: string;
}> = {
  Source: {
    module: 'Founder portal · Deal Radar',
    metric: '128 inbound'
  },
  Screen: {
    module: 'Fit Score per fund',
    metric: '41 screened'
  },
  Diligence: {
    module: 'Reports · Risk · Comps',
    metric: '12 active'
  },
  IC: {
    module: 'Votes · Memo · Comments',
    metric: '4 this week'
  },
  Invest: {
    module: 'Decision record',
    metric: '2 closed'
  },
  Portfolio: {
    module: 'Company updates',
    metric: '36 companies'
  },
  'LP Reporting': {
    module: 'Structured reporting',
    metric: 'Q3 draft'
  }
};
export function LifecycleSection() {
  return <section aria-labelledby="lifecycle-heading" className="border-b border-hairline-soft bg-surface" data-id="element-195" data-mp="1xm1cecjqgbyl">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-196" data-mp="22kunxzfglsw4">
        <SectionHeading eyebrow="Operating System" headingId="lifecycle-heading" title={<>
              One Operating System. <em data-id="element-198" data-mp="2sd38lspl4ca9">Every Venture Workflow.</em>
            </>} data-id="element-197" data-mp="321uxtt39gihh" />

        <Reveal delay={0.08} className="mt-14" data-id="element-199" data-mp="2sb082eqt30ra">
          <div className="sf-scrollbar -mx-4 overflow-x-auto px-4 pb-2 sm:mx-0 sm:px-0" data-id="element-200" data-mp="2ocay6w4z81ce">
            <ol className="flex min-w-[960px] items-stretch gap-1" data-id="element-201" data-mp="2jcy4brfotu0b">
              {LIFECYCLE.map((stage, index) => <li key={stage} className="flex flex-1 items-center gap-1" data-id="element-202" data-mp="2ecafncexlp99" data-mpi={index}>
                  <div className="flex h-full flex-1 flex-col gap-3 rounded-xl border border-hairline bg-panel p-4 transition-colors duration-200 hover:border-lime/30" data-id="element-203" data-mp="29dpb50sncjf0">
                    <span className="font-mono text-[10px] text-text-tertiary" data-id="element-204" data-mp="25ezxr87lz1vd">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <span className="text-sm font-semibold uppercase tracking-[0.12em] text-text-primary" data-id="element-205" data-mp="3ls9vadxjbxv">
                      {stage}
                    </span>
                    <span className="text-[11px] leading-snug text-text-secondary" data-id="element-206" data-mp="21uzk2pdpdb4i">
                      {STAGE_DETAIL[stage].module}
                    </span>
                    <span className="mt-auto inline-flex w-fit items-center gap-1.5 rounded-md border border-hairline-soft bg-elevated px-2 py-1 font-mono text-[10px] text-lime" data-id="element-207" data-mp="1o1hzd19a5scw">
                      <span className="h-1 w-1 rounded-full bg-lime" aria-hidden="true" data-id="element-208" data-mp="2fvaajrb3onp5" />
                      {STAGE_DETAIL[stage].metric}
                    </span>
                  </div>
                  {index < LIFECYCLE.length - 1 ? <ChevronRightIcon className="h-4 w-4 shrink-0 text-text-tertiary" aria-hidden="true" data-id="element-209" data-mp="2bsnj3ricd4sh" /> : null}
                </li>)}
            </ol>
          </div>
        </Reveal>
      </div>
    </section>;
}